export default "__VITE_ASSET__8bc3a28f__"